<wb-card [clickable]="clickable()" [selected]="selected()" [compact]="compact()">
  <ng-template wbCardIdentifier>{{ $identifier() }}</ng-template>
  <ng-template wbCardStatus>
    @if ($isFinancial()) {
      {{ $heroAmount() }}
    } @else {
      {{ $status() }}
    }
  </ng-template>
  <!-- Only when there is something to show: a projected template makes wb-card lay out the title group, so an
       empty one left a gap under the identifier (cards whose view sets no title or description). -->
  @if ($title()) {
    <ng-template wbCardTitle>{{ $title() }}</ng-template>
  }
  @if ($descriptionField() && $description()) {
    <ng-template wbCardDescription>
      <wb-value class="wb-card-description-value" [class.is-clamped]="!$descriptionIsAddress()" [value]="$descriptionValue()" [field]="$descriptionField()" [data]="item()" addressLayout="lines" [title]="$description()" />
    </ng-template>
  }
  @for (entry of $bodyEntries(); track entry.field.path ?? entry.field.name) {
    <ng-template wbCardRow>
      <span class="wb-card-row-label" clippedTooltip [pTooltip]="entry.field.displayName ?? entry.field.name" tooltipPosition="top" [showDelay]="500" appendTo="body">{{ entry.field.displayName ?? entry.field.name }}</span>
      <wb-value class="wb-card-row-value" [value]="entry.value" [field]="entry.field" [data]="item()" [truncate]="true" [title]="entry.title" />
    </ng-template>
  }
  @if ($footerTags().length) {
    <ng-template wbCardFooter>
      @for (tag of $footerTags(); track tag._id) {
        @if (tag.mode) {
          <wb-badge [mode]="tag.mode" [label]="tag.name" [color]="tag.color" [backgroundColor]="tag.backgroundColor" [borderColor]="tag.borderColor" [tooltip]="tag.tooltip" size="xs" />
        } @else {
          <wb-badge [mode]="BadgeMode.Tag" [label]="tag.name" [backgroundColor]="tag.color" size="xs" />
        }
      }
    </ng-template>
  }
</wb-card>
